import { combineReducers } from "redux";
import login from './login.reducer';
import tabReducer from "./tab.reducer";
import sidebarReducer from "./sidebar.reducer";
import loaderReducer from "./loader.reducer";
import skutableReducer from "./skuTable.reducer";
import permissionsReducer from "./permissions.reducer";
import langReducer from "./lang.reducer";   // <-- ADD THIS

import facilityReducer from "./facility.reducer";


const appReducer = combineReducers({
  login,
  tab: tabReducer,
  sidebar: sidebarReducer,
  loader : loaderReducer,
  skutable: skutableReducer,
  permissions: permissionsReducer,  

  lang: langReducer,
  permissions: permissionsReducer,
  facility: facilityReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
